import * as Actions from './actions';
import initialState from '../store/initialState';
import { Action, Product } from './types';
import {updateProductSortOrder} from "./thunks";

// 第一引数にState(現在のstateの状態)。初期状態をデフォルトとして設定
// 第二引数にactionがreturnした値(typeとpayload)
export const ProductsReducer = (state = initialState.products, action: Action) => {
  // Actionsのtypeに応じてstateをどう変更するのか決める
  switch (action.type) {
    case Actions.DELETE_PRODUCT:
      return {
        ...state,
        list: action.payload as Product[],
      }; //TODO: 使用されていないので消去
    case Actions.SAVE_RECEIVED_DATE:
      return {
        ...state,
        received_date: action.payload,
      };
      case Actions.RESET_RECEIVED_DATE:
        return{
          ...state,
          received_date: initialState.products.received_date,
        };
    case Actions.ADD_PRODUCT:
      return {
        ...state,
        list: [...state.list, action.payload as Product]
      }
    case Actions.SET_PRODUCTS:
      return {
        ...state,
        list: action.payload as Product[]
      }
    case Actions.UPDATE_PRODUCT:
      const newList = state.list.slice()
          .filter(e => e.id !== action.payload.id);
      newList.push(action.payload);
      return {
        ...state,
        list: newList
      }
    case Actions.CHANGE_PRODUCT_STATUS:
      return {
        ...state,
        status: action.payload
      }
    case updateProductSortOrder.fulfilled.name:
      return {
        ...state,
        list: action.payload.products as Product[]
      }
    default:
      return state;
  }
}
